jQuery(document).ready(function ($) {


	$(function () {

		if ($('.video-header-banner__video-wrapper').length > 0) {
			var video = $("#video-player")[0];

			if (video.tagName == "IFRAME") {
				player.playVideo();
			} else {
				createVideo(video);
			}
		}

	});

	function createVideo(video) {
		var youtubeScriptId = "youtube-api";
		var youtubeScript = document.getElementById(youtubeScriptId);
		var videoId = video.getAttribute("data-video-id");

		if (youtubeScript === null) {
			var tag = document.createElement("script");
			var firstScript = document.getElementsByTagName("script")[0];

			tag.src = "https://www.youtube.com/iframe_api";
			tag.id = youtubeScriptId;
			firstScript.parentNode.insertBefore(tag, firstScript);
		}

		window.onYouTubeIframeAPIReady = function () {
			window.player = new window.YT.Player(video, {
				videoId: videoId,
				playerVars: {
					mute: 1,
					autoplay: 1,
					controls: 0,
					showinfo: 0,
					autohide: 0,
					enablejsapi: 1,
					modestbranding: 1, // show smaller logo
					wmode: 'transparent',
					branding: 0,
					rel: 0,
					origin: 'https://www.youtube.com' // not sure this is right
				},
				allowfullscreen: 1,
				events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
				}
			});
			function onPlayerReady(event) {
				event.target.playVideo();
			}
			function onPlayerStateChange(event) {
				if (event.data === YT.PlayerState.ENDED) {
					player.playVideo();
				}
			}
		};
	}


});
